import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { Order } from '../types';

export function useOrders() {
  return useQuery({
    queryKey: queryKeys.orders.all,
    queryFn: () => apiClient.get<Order[]>('/orders'),
  });
}
